<template>
  <v-toolbar style="margin-bottom: 20px;">
    <v-toolbar-title>{{ getUser.name || "Loading..."}}</v-toolbar-title>

    <div class="flex-grow-1"></div>

    <v-btn icon>
      <router-link :to="{name: 'logout'}"><v-icon>mdi-logout</v-icon></router-link>
    </v-btn>
  </v-toolbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TopBar',
  methods: {
    ...mapActions(['fetchUserData'])
  },
  computed: {
    ...mapGetters(['getUser'])
  },
  created () {
    this.fetchUserData()
  }
}
</script>
